import React from 'react'
import { Appearance, ColorSchemeName, useColorScheme } from 'react-native'
import { getTheme, Theme } from './index'

type ThemeState = {
  mode: ColorSchemeName
  theme: Theme
}

// set default colour scheme from OS
const osTheme = Appearance.getColorScheme()

// initiate context
export const ManageThemeContext: React.Context<ThemeState> = React.createContext<ThemeState>({
  mode: osTheme,
  theme: getTheme(osTheme),
})

// define useTheme hook for functional components
export const useTheme = (): ThemeState => React.useContext(ManageThemeContext)

// initiate context provider
export function ThemeManager(props: { children: any }): React.JSX.Element {
  const colorScheme = useColorScheme()

  const theme = {
    mode: colorScheme,
    theme: getTheme(colorScheme),
  }

  return <ManageThemeContext.Provider value={theme}>{props.children}</ManageThemeContext.Provider>
}

export default ThemeManager
